const convertToEnglishNumber= (str)=>{
    const persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g]
  
    if(typeof str === 'string'){
      for(let i=0; i<persianNumbers.length; i++){
        str = str.replace(persianNumbers[i], i);
      }
    }
    return str;
  };
  
const numberRegex = (value) => {
  const pattern = /^[0-9۰-۹]+$/;
  return pattern.test(value);
}

export {convertToEnglishNumber, numberRegex}